import React, { useState, useEffect } from "react";
import Avatar from '../assets/avatar.png'
import "./HeroSection.css";
import { Link } from "react-router-dom";
const HeroSection = () => {




    return (

        <section className="hero-section">
            <div className="hero-container">


                <div className="hero-content animate-on-scroll">
                    <h1 className="hero-title">HEY, I'M<br />HARSH BHAGAT</h1>
                    <p className="hero-subtitle">
                        India's Leading Trader, Investor, and Strategy Architect — not just a mentor,
                        but the mind behind multiple high-performance trading systems. I don't teach trends.
                        I build traders. Welcome to the ecosystem that's creating India's most self-reliant trading community.
                    </p>

                    <div className="hero-buttons">

                        <Link to="https://telegram.openinapp.co/i1n51" target="_blank" className="btn btn-primary hero-btn-primary">

                            Join Inner Circle
                            <img src="./assets/icons/crown.svg" alt="crown" />
                        </Link>
                        <a href="#story" className="btn btn-secondary hero-btn-secondary">
                            My Story →
                        </a>

                    </div>

                    <div className="hero-profile-section">
                        <div className="hero-blur-effect"></div>
                        <div className="hero-profile-image">
                            <img width={320} className='hero-image-home' src={Avatar} alt="Harsh Bhagat" />


                            <div className="profile-badge">
                                <p className="badge-title">India's No. 1</p>
                                <p className="badge-subtitle">Trader • Investor • Mentor</p>
                            </div>

                            <div className="subscriber-badge">

                                <p>600K+ Subscribers</p>
                            </div>
                        </div>

                        <div className="background-text">HARSH</div>

                        <div className="hero-circles">
                            <div className="circle circle-1"></div>
                            <div className="circle circle-2"></div>
                            <div className="circle circle-3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default HeroSection;
